import React, {useEffect, useState} from 'react';
import classes from 'classnames';
import styles from './index.module.less';
import {Classes, Dialog, Intent, ProgressBar, Toaster} from "@blueprintjs/core";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Avatar from "react-avatar";
import QrCode from 'qrcode.react';

const PartFinished = () => {
  const [shareInfo, setShareInfo] = useState(null);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [evaluated, setEvaluated] = useState(false);
  const [params, setParams] = useState(null);
  const history = useHistory();
  useEffect(() => {
    const storedShareInfo = JSON.parse(window.sessionStorage.getItem('share-info'));
    if (!storedShareInfo) {
      history.replace('/');
      return;
    }
    setParams(storedShareInfo);
  }, [history]);
  useEffect(() => {
    if (!params) {
      return;
    }
    axios.get('/api/course/get_share_info', {
      params: {
        object_id: params.pathId,
        share_type: 'learn_path'
      }
    }).then(response => {
      const { code, data } = response.data;
      if (code === 0) {
        setShareInfo({ ...data.share_info, share_key: data.share_key })
      }
    })
  }, [history, params]);

  const handleEvaluate = (score) => {
    if (evaluated) {
      return;
    }
    axios.post('/api/course/rate_score', {
      object_id: params.pathId,
      rate_type: 'learn_path',
      score
    }).then((response) => {
      Toaster.create({
        usePortal: true,
      }).show({
        message: '感谢您的评价！',
        intent: Intent.SUCCESS
      });
      setEvaluated(true);
    }).catch(() => {
      setEvaluated(false);
    });
  };

  const handleRedirectToNextLesson = () => {
    if (params.next.chapterId) {
      history.push(`/learn/${params.next.chapterName}/${params.next.chapterId}/${params.next.lessonId}`)
    }
  };
  if (!params) {
    return null;
  }
  return (
    <div className={styles['part-finished']}>
      {shareInfo && (
        <>
          <div className={styles.main}>
            <div className={styles['card-list']}>
              <div className={classes(styles.card, styles.light)}>
                <div className={styles.awards} />
                <div className={styles['part-name']}>{`第${shareInfo.course_info.learn_path_no}部分\n${shareInfo.course_info.learn_path_name}`}</div>
                <div className={styles.congratulations}>恭喜你</div>
                <div className={styles['finish-text']}>本章学习已完成</div>
                <div className={styles.feedback}>
                  <div className={styles.title}>课程反馈 {evaluated && '(已评价)'}</div>
                  <div className={styles.options}>
                    <div className={classes(styles.option, evaluated && styles.evaluated, styles.one)} onClick={() => handleEvaluate(1)} />
                    <div className={classes(styles.option, evaluated && styles.evaluated, styles.three)} onClick={() => handleEvaluate(3)} />
                    <div className={classes(styles.option, evaluated && styles.evaluated, styles.five)} onClick={() => handleEvaluate(5)} />
                  </div>
                </div>
              </div>
              <div className={classes(styles.card, styles.dark)}>
                <div className={styles.cover}>
                  <Avatar className={styles.avatar} name={shareInfo.user_info.user_name} size={68} />
                  <div className={styles['course-name']}>{shareInfo.course_info.course_name}</div>
                </div>
                <div className={styles.progress}>
                  <div className={styles.title}>课程进度 {Math.ceil(shareInfo.course_info.learn_progress * 100)}%</div>
                  <ProgressBar stripes={false} animate={false} intent={Intent.SUCCESS} value={shareInfo.course_info.learn_progress} className={styles['progress-bar']} />
                </div>
                <div className={styles['data-grid']}>
                  <div className={styles['data-item']}>
                    <div className={styles.name}>学习时长</div>
                    <div className={styles.data}>{(shareInfo.course_learn_time / 60 / 60).toFixed(2)} 小时</div>
                  </div>
                  <div className={styles['data-item']}>
                    <div className={styles.name}>完成Python挑战</div>
                    <div className={styles.data}>{shareInfo.instruction_num}个</div>
                  </div>
                  <div className={styles['data-item']}>
                    <div className={styles.name}>运行代码</div>
                    <div className={styles.data}>{shareInfo.code_line_num}行</div>
                  </div>
                </div>
                <div className={styles.action} onClick={() => setShareDialogOpen(true)}>我要打卡</div>
              </div>
            </div>
          </div>
          <div className={styles.footer}>
            <div className={styles.btn} onClick={() => window.open('/', '_self')}>返回首页</div>
            {params.next.chapterId && (
              <div className={styles.btn} onClick={handleRedirectToNextLesson}>学习下一章</div>
            )}
          </div>
        </>
      )}
      <Dialog onClose={() => setShareDialogOpen(false)} usePortal isOpen={shareDialogOpen} className={styles['share-dialog']} canOutsideClickClose canEscapeKeyClose>
        <div className={Classes.DIALOG_HEADER}>
          扫描下面二维码分享至朋友圈
        </div>
        <div className={classes(Classes.DIALOG_BODY, styles['qr-code'])}>
          {shareInfo && (
            <QrCode size={232} value={`http://study.pythontip.com/#/share/${shareInfo.share_key}`}/>
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default PartFinished;
